import {Button, ComponentClassName} from "@dp-instant/ui";
import {SVG} from "@game/ui/images";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import "./SettingsButton.less";
import {playUIClickSound} from "@game/helpers";

export const SettingsButton = ({
    className,
    onClick
}: IClickableComponentProps & ComponentClassName) => (
    <Button
        className={cn("button", "settings-button", className)}
        onClick={() => {
            if (onClick) {
                playUIClickSound();
                onClick();
            }
        }}
    >
        <SVG.Settings />
    </Button>
);
